import type React from 'react';

export const InsetDark = ({children}: {children: React.ReactNode}) => <div className="panel-inset">{children}</div>;
